<template>
    <div class="card-header" style="border:0">
        <h3 class="card-title">Epoch {{ epoch  }}</h3>
        <div class="w-75 m-auto p-3" >

            <b-progress
                :value="(parseFloat(epochProgress || 0) *100).toFixed(0)"
                max="100"
                show-progress
                variant="success"
                type="line"
                :text-inside="false"
                style="max-height: 56px"
                width="500"
            />
        </div>
        <div class="card-options small`">
            {{ timeLeftInEpoch }} left
        </div>
    </div>
</template>

<script>
import {
    Authorized,
    Connection,
    Keypair,
    Lockup,
    PublicKey,
    sendAndConfirmTransaction,
    StakeProgram,
    Transaction
} from "@solana/web3.js";

const connection = new Connection('https://specific-lanny-fast-mainnet.helius-rpc.com/', {
// const connection = new Connection('http://localhost:8899/', {
// const connection = new Connection('https://api.devnet.solana.com', {
    commitment: 'confirmed',
    confirmTransactionInitialTimeout: 12000
});


export default {
    name: "EpochTime",
    data() {
        return {
            epochInfo: {},
            epochProgress: 0,
            epochTimeRemaining: 0,
            epoch: 0,
        }
    },
    mounted() {
        this.getDashboardEpochInfo();
        setInterval(() => {
            this.getDashboardEpochInfo();
        }, 10000);
    },
    methods: {
        async getDashboardEpochInfo() {
            // Inspired from explorer.solana.com DashboardInfo
            const epochInfo = await connection.getEpochInfo();
            const {slotIndex, slotsInEpoch, epoch} =  epochInfo;

            const epochProgress = slotIndex / slotsInEpoch;

            const samples = await connection.getRecentPerformanceSamples(60);
            // const samples = [{samplePeriodSecs: 550, numSlots: 1000}] // Hardcoded until mystery above is solved
            console.log(samples)
            const timePerSlotSamples = samples
                .filter((sample) => {
                    return sample.numSlots !== 0;
                })
                .slice(0, 60)
                .map((sample) => {
                    return sample.samplePeriodSecs / sample.numSlots;
                })
            console.log(timePerSlotSamples)
            const samplesInHour = timePerSlotSamples.length < 60 ? timePerSlotSamples.length : 60;
            const avgSlotTime_1h =
                timePerSlotSamples.reduce((sum, cur) => {
                    return sum + cur;
                }, 0) / samplesInHour;

            const hourlySlotTime = Math.round(1000 * avgSlotTime_1h);
            const epochTimeRemaining = (slotsInEpoch - slotIndex) * hourlySlotTime;

            console.log(`epochProgress: ${epochProgress}, epochTimeRemaining: ${epochTimeRemaining}`);
            this.epochInfo = epochInfo;
            this.epoch = epoch
            this.epochProgress = epochProgress;
            this.epochTimeRemaining = epochTimeRemaining;
            return {
                epochInfo,
                epochProgress,
                epochTimeRemaining,
            };
        },

    },
    computed: {
        timeLeftInEpoch() {
            let now = new Date();
            let end = this.epochTimeRemaining || 0
            let then = new Date( now.getTime() + end )
            let diff = new Date(then - now)
            let days = diff.getUTCDate() -1;
            let hours = diff.getUTCHours();
            let mins = diff.getUTCMinutes();
            let response = ''
            if (days>0) response +=days +'d '
            response += hours+'h ' + mins+'m'
            console.log('time left',response)
            return response

        },
    }
}
</script>

<style scoped>

</style>
